const url = "/empresas";
const id = "idenEmpresa";

export const initForm = {
  idenEmpresa: 0,
  nomeFantasia: "",
  razaoSocial: "",
  descInscEstadual: "",
  cnpjMask: "0",
  cnpj: 0,
};

export function pesquisarAll() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/all`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarLista() {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/lista`).then((res) => {
      resolve(res.data);
    });
  });
}
export function buscaPersonalizada(buscaPersonalizada) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/buscaPersonalizada/${buscaPersonalizada}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function pesquisarPorId(idenEmpresa) {
  return new Promise((resolve, reject) => {
    window.$http.get(`${url}/${idenEmpresa}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvar(parm) {
  return new Promise(async (resolve, reject) => {
    if (parm[id] && parm[id] !== 0) {
      await atualizar(parm).then((res) => {
        resolve(res);
      });
    } else {
      await criar(parm).then((res) => {
        resolve(res);
      });
    }
  });
}

export function atualizar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, reject) => {
    window.$http.post(`${url}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function excluirEmpresa(id) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`${url}/${id}`).then((res) => {
      resolve();
    });
  });
}
